import * as required from './required';
import * as email from './email';
import * as url from './url';
import * as date from './date';
import * as birthday from './birthday';
import * as year from './year';

const rules = {
  required,
  email,
  url,
  date,
  birthday,
  year
};

export default rules;
